import t from "react";
/* empty css            */
const l = ({
  name: e,
  src: r
}) => {
  function i(m) {
    const [a, n] = m.split(" ");
    return a && n ? `${a.charAt(0)}${n.charAt(0)}` : a ? a.charAt(0) : "";
  }
  return /* @__PURE__ */ t.createElement("div", { className: "rnf-avatar" }, r ? /* @__PURE__ */ t.createElement("img", { src: r, alt: `Image of ${e}`, className: "rnf-avatar__image" }) : /* @__PURE__ */ t.createElement("span", { className: "rnf-avatar__initials" }, i(e)));
};
export {
  l as Avatar
};
//# sourceMappingURL=Avatar.mjs.map
